import { TREND_AXIS_MODE } from '../../../filters/lib/statisticsTrendDimension';
import { resolvePersistedChartKind, PERSISTED_CHART_KIND } from './statisticsPersistedCharts';
import { TREND_CHART_TYPE } from '../../trend/lib/trendChartConfig';
import { isCompositionChartMapType } from '../../composition/lib/compositionChartConfig';

/** 仪表板图表弹窗（xl 展开 / 全屏）统一绘图区高度，避免 fillHeight 在非统计页缺少 SCSS 时画布高度为 0 */
export const resolveDashboardChartModalHeight = (snapshot, chartBundle, variant = 'full') => {
	const chartKind = resolvePersistedChartKind(snapshot);
	if (chartKind === PERSISTED_CHART_KIND.OVERDUE) {
		return variant === 'full' ? '13rem' : '8rem';
	}
	if (chartKind === PERSISTED_CHART_KIND.COMPOSITION) {
		const isMapChart = isCompositionChartMapType(chartBundle?.chartConfig?.chartType);
		if (variant === 'full') return isMapChart ? '18rem' : '12rem';
		return '7.5rem';
	}
	const axisMode = chartBundle?.trendAxisMode;
	const chartType = chartBundle?.trendChartType;
	if (chartType === TREND_CHART_TYPE.MAP) {
		return variant === 'full' ? '18rem' : '7.5rem';
	}
	const isCustomer = axisMode === TREND_AXIS_MODE.CUSTOMER;
	if (variant === 'full') return isCustomer ? '16.5rem' : '14rem';
	return isCustomer ? '11.5rem' : '10rem';
};

export default resolveDashboardChartModalHeight;
